import RevokeTokenDialog from './RevokeTokenDialog';

export default RevokeTokenDialog;
